export default "__VITE_ASSET__CwEsW0SC__"